(() => {
  if (window.__ssQuizLoaderReady) return;
  window.__ssQuizLoaderReady = true;

  const currentSrc = document.currentScript?.src || '';
  const assetUrl = (filename) => {
    const url = new URL(currentSrc, window.location.href);
    url.pathname = url.pathname.replace(/secret-santa-quiz\.js$/, filename);
    url.search = '';
    return url.toString();
  };

  const load = (filename) => new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-ss-quiz-loader-file="${filename}"]`);
    if (existing) {
      if (existing.dataset.loaded === 'true') resolve();
      else {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
      }
      return;
    }

    const script = document.createElement('script');
    script.src = assetUrl(filename);
    script.async = false;
    script.dataset.ssQuizLoaderFile = filename;
    script.addEventListener('load', () => {
      script.dataset.loaded = 'true';
      resolve();
    }, { once: true });
    script.addEventListener('error', reject, { once: true });
    document.head.appendChild(script);
  });

  const boot = async () => {
    try {
      if (!window.SecretSantaQuizEngine) await load('secret-santa-quiz-engine.js');
      await load('secret-santa-quiz-budget-fix.js');
      await load('secret-santa-quiz-ui.js');
    } catch (error) {
      console.error('[Secret Santa Quiz] Impossible de charger le questionnaire.', error);
    }
  };

  boot();
})();
